var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-chart',{class:{ 'chart': true },staticStyle:{"margin-top":"20px","width":"100%"},attrs:{"id":"id","option":_vm.option}}),_c('el-button',{on:{"click":_vm.hidelable}},[_vm._v(_vm._s(_vm.labelstatustext))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }